import TextField from '@mui/material/TextField';
import React from 'react';
import FormWithDescription from '../../FormWithDescription';
import OnOffSwitch from './OnOffSwitch';

export default function Integrations({
  googleAnalytics,
  setGoogleAnalytics,
  headerInjection,
  setHeaderInjection,
  adstxt,
  setAdstxt,
  useHostingUrl,
  setUseHostingUrl,
  blog,
}) {
  const { plan } = blog;

  return (
    <>
      <div>
        <FormWithDescription
          title="Google Analytics"
          description={
            <>
              <p>
                If you want to track your blog&apos;s visitors, you can connect
                your blog to your Google Analytics account here. Please be aware
                that cookie-based tracking may require your visitors&apos;
                consent in some legislations. Currently, only Google Analytics
                is supported natively, but you can implement other analytics
                solutions by adding a tracking script with code injection below.
              </p>
              <p>
                You can find your Google Analytics Measurement ID in your
                Analytics dashboard. It should look something like this:{' '}
                <code>G-123XXXX321</code>
              </p>
            </>
          }
          isWide
        >
          <TextField
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
            label="Measurement ID"
            variant="outlined"
            value={googleAnalytics}
            onChange={e => setGoogleAnalytics(e.target.value)}
          />
        </FormWithDescription>
        <FormWithDescription
          title="Code injection"
          description={
            <>
              <p>
                Code you enter here will be injected into the &quot;head&quot;
                tag on every page of your site. This can be used for custom meta
                tags (e.g. Google Search Console verification), custom scripts
                (e.g. Adsense, Analytics or other 3rd party service
                integrations) or custom styles.
              </p>
              <p>
                Warning: Only use code injection if you know what you are doing
                since this can break your page or leave it open to hackers!
              </p>
            </>
          }
          marginTop
          isWide
        >
          <TextField
            multiline
            fullWidth
            inputProps={{
              maxLength: 4500,
            }}
            id="headerInjection"
            label="Header injection"
            variant="outlined"
            value={headerInjection}
            onChange={e => setHeaderInjection(e.target.value)}
          />
        </FormWithDescription>
        <FormWithDescription
          title="Ads.txt"
          description="If you are using an advertising script that requires an ads.txt file
          (e.g. Google Adsense), you can paste the contents of the ads.txt
          file here."
          marginTop
          isWide
        >
          <TextField
            multiline
            fullWidth
            inputProps={{
              maxLength: 4000,
            }}
            id="adstxt"
            label="Ads.txt contents"
            variant="outlined"
            value={adstxt}
            onChange={e => setAdstxt(e.target.value)}
          />
        </FormWithDescription>
        {plan !== 'trial' && (
          <OnOffSwitch
            value={!!useHostingUrl}
            setValue={setUseHostingUrl}
            title="Auto canconical links"
            description="Automatically set a canonical links to your blog for all posts on TravelFeed and cross-posting. Good for SEO to prevent duplicate content."
            label="Auto canconical links"
            marginTop
            isWide
          />
        )}
      </div>
    </>
  );
}
